



































import { Component, Vue } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import routerLinkButton from '@/components/elements/buttons/router-link-button.vue';
import { DataTableState, TableContext } from '@/typings/datatable';
import DataTableWithFilters, { DataTableFilter } from '@/components/datatable-filters.vue';

import { OrgsApi, Product, ProductsApi, ProductType, VatsApi } from '@/api';
import { ApiUtils, FilterParam } from '@/common/ApiUtils';
import { ProductStatusService } from '@/services/product-status-service';

@Component({
	components: {
		secondaryNav,
		DataTableWithFilters,
		routerLinkButton,
	},
})
export default class ProductsList extends Vue {
	public state: DataTableState = {
		fields: [
			{ key: 'id', sortable: true },
			// {key: 'supplierDisplay',  label: 'SupplierNumber', sortable: true},
			{ key: 'name', label: 'Product', sortable: true },
			{
				key: 'status',
				sortable: true,
				formatter: (status: string, key: string, item) =>
					ProductStatusService.formatProductStatus(status, item.termsState),
			},
			{ key: 'site.name', label: 'Site', sortable: false },
			{ key: 'milkCompanyName', label: 'Company', sortable: false },
			{ key: 'type', label: 'Type', sortable: true },
			{ key: 'faultStatus', label: 'Fault Status', sortable: true },
			// {key: 'lastCalibratedAt',  label: 'Calibrated', sortable: true},
		],
		loading: false,
		search: null,
		sortBy: 'id',
		primaryKey: 'id',
		sortDesc: false,
		perPage: 20,
		currentPage: 1,
		totalRows: 0,
	};

	public filters: DataTableFilter[] = [
		{
			label: 'Type',
			field: 'type',
			value: [],
			type: 'checkboxes',
			options: [
				{ text: 'Milk', value: 'milk' },
				{ text: 'Fuel', value: 'fuel' },
				{ text: 'Water', value: 'water' },
				{ text: 'Effluent', value: 'effluent' },
				{ text: 'Feed', value: ProductType.Feed },
			],
		},
		{
			label: 'Status',
			field: 'status',
			value: [],
			type: 'checkboxes',
			options: [
				{ text: 'Cancelled', value: 'cancelled' },
				{ text: 'Install', value: 'install' },
				{ text: 'Live', value: 'live' },
				{ text: 'Pending', value: 'pending' },
				{ text: 'Removed', value: 'removed' },
				{ text: 'Sign Off', value: 'sign-off' },
				{ text: 'Draft', value: 'draft' },
			],
		},
		{
			label: 'Milk company',
			field: 'supplier',
			value: [],
			type: 'checkboxes',
			options: [],
		},
		{
			label: 'Fault Statuses',
			field: 'faultStatus',
			value: [],
			type: 'checkboxes',
			options: [
				{ text: 'Contact', value: 'contact' },
				{ text: 'Monitor', value: 'monitor' },
				{ text: 'New', value: 'new' },
				{ text: 'Reboot', value: 'reboot' },
			],
		},
	];

	public searchBy = { value: 'custom' };

	private api: ProductsApi;
	private vatsApi: VatsApi;

	constructor() {
		super();
		this.api = new ProductsApi();
		this.vatsApi = new VatsApi();
	}
	public created() {
		this.getPartnerOrgsByProductType();
	}
	public reload() {
		this.$root.$emit('bv::refresh::table', 'products-datatable');
	}

	public clickTable(item: any, newtab: boolean) {
		if (newtab) {
			const routeData = this.$router.resolve({
				name: `products.${item.type}.view`,
				params: { productId: item.id },
			} as any);
			window.open(routeData.href, '_blank');
		} else {
			this.$router.push({
				name: `products.${item.type}.view`,
				params: { productId: item.id },
			} as any);
		}
	}

	public async dataTableProvider(ctx: TableContext) {
		let data: any = [];
		try {
			const filters: FilterParam[] = this.filters.map((filter: DataTableFilter) => {
				return { field: filter.field, value: filter.value };
			});
			if (this.searchBy.value === 'vatId' && this.state.search) {
				const prodId = await this.getProductId(filters, ctx);
				filters.push({ field: 'id', value: prodId });
			}
			if (this.state.search && this.searchBy.value !== 'vatId') {
				// filters.push({field: 'supplierNumber', value: this.state.search});
				filters.push({ field: 'custom', value: this.state.search });
			}
			const response = await this.api.getProducts(
				ApiUtils.queryOptions(filters, ctx, { params: { include: 'vats,site' } }),
			);
			const respData = response.data.data;
			data = respData.map((prod: any) => {
				if (!prod.name.startsWith(prod.supplierNumber)) {
					prod.name = `${prod.supplierNumber ? `${prod.supplierNumber} - ` : ''}${prod.name}`;
				}
				return prod;
			});

			this.state.totalRows = response.data.meta.total || 0;
		} catch (e) {
			this.state.totalRows = 0;
		}
		return data;
	}

	public async getPartnerOrgsByProductType() {
		try {
			const response = await new OrgsApi().orgGetPartnersByProductType('milk');
			this.filters[2].options = response.data.data.map(supplier => {
				return { text: supplier.name, value: supplier.supplierCode };
			});
		} catch (e) {
			console.log(e);
		}
	}

	public async getProductId(filters: FilterParam[], ctx: TableContext) {
		let data: any = [];
		const vatFilters: FilterParam[] = [...filters];
		if (this.state.search) {
			vatFilters.push({ field: 'id', value: this.state.search });
		}
		const response = await this.vatsApi.getVats(ApiUtils.queryOptions(vatFilters, ctx));
		data = response.data.data;
		return data[0].productId;
	}
}
